<template>
    <div>
        <SourceFilterInput v-model="listValue" ></SourceFilterInput>
    </div>
</template>

<script>
  import axios from 'axios';
  import {mapState} from 'vuex';
  import SpecialityMultiplePickerInput from '@/components/inputs/SpecialityMultiplePickerInput.vue';
  import SourceFilterInput from '@/components/inputs/SourceFilterInput';

  export default {
    name: "Test",
    components: {
      SpecialityMultiplePickerInput,
      SourceFilterInput
    },
    data: () => ({
      listValue: [],
      objectiveSpecialities:[],
      degreeTypeId: 1,
      source: null
    }),
    computed: {
      ...mapState(['counter'])
    },
    created() {
      // this.$store.state.counter = this.$store.state.counter + 1;
      // console.log(this.$store.state.counter);
    },
    methods: {
      send() {
        axios.get('http://localhost/test-cancel.php', {
          time: 123456,
          cancelToken: this.source.token
        })
          .then(function (resp) {
            console.log(resp.config.time, resp);
          })
          .catch(function (thrown) {
            if (axios.isCancel(thrown)) {
              console.log('Request canceled', thrown.message);
            }
            else {
              // handle error
            }
          });
      },
      cancel() {
        if (this.source) {
          this.source.cancel('Operation canceled by the user.');
        }

        this.source = axios.CancelToken.source();

        this.send();
      }
    }
  }
</script>

<style scoped>

</style>
